import { useRef } from "react";

function useSwipe(input) {
  const { thershold = 50, onSwipeLeft, onSwipeRight, onSwipeUp, onSwipeDown } = input
  const touch = useRef({
    startX: null,
    endX: null,
    startY: null,
    endY: null
  })

  function onTouchStart(e) {
    touch.current.endX = null
    touch.current.startX = e.targetTouches[0].clientX

    touch.current.endY = null
    touch.current.startY = e.targetTouches[0].clientY
  }

  function onTouchMove(e) {
    touch.current.endX = e.targetTouches[0].clientX
    touch.current.endY = e.targetTouches[0].clientY
  }

  function onTouchEnd() {
    if (touch.current.startX && touch.current.endX) swipeHorizontal()
    if (touch.current.startY && touch.current.endY) swipeVertical()
  }

  function swipeHorizontal() {
    const xDistance = touch.current.startX - touch.current.endX
    const yDistance = touch.current.startY - touch.current.endY
    if (Math.abs(yDistance) >= Math.abs(xDistance)) {
      return;
    }

    const isLeftSwipe = xDistance > thershold
    const isRightSwipe = xDistance < -thershold

    if (onSwipeLeft && isLeftSwipe) {
      onSwipeLeft();
    }

    if (onSwipeRight && isRightSwipe) {
      onSwipeRight();
    }
  }

  function swipeVertical() {
    const xDistance = touch.current.startX - touch.current.endX
    const yDistance = touch.current.startY - touch.current.endY
    if (Math.abs(xDistance) >= Math.abs(yDistance)) {
      return;
    }

    const isUpSwipe = yDistance > thershold
    const isDownSipe = yDistance < -thershold

    if (onSwipeDown && isDownSipe) {
      onSwipeDown();
    }

    if (onSwipeUp && isUpSwipe) {
      onSwipeUp();
    }
  }

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  }
}

export default useSwipe